import { useEffect, useRef } from 'react';
import useGameStore from '../store/gameStore';
import useAudioStore from '../store/audioStore';

/**
 * Hook that listens for new notifications and plays appropriate sounds.
 * Also plays a dedicated 'inboxDing' when a new Messagerie message arrives.
 * Place once in App or Layout.
 */
export const useGameSounds = () => {
  const notifications = useGameStore((s) => s.notifications);
  const inbox = useGameStore((s) => s.inbox);
  const playSound = useAudioStore((s) => s.play);
  const prevNotifCountRef = useRef(0);
  const prevInboxCountRef = useRef(null); // null on first mount → skip seed welcome

  useEffect(() => {
    const count = (notifications || []).length;
    if (count > prevNotifCountRef.current && prevNotifCountRef.current > 0) {
      const latest = notifications[notifications.length - 1];
      if (latest?.type === 'achievement') {
        playSound('achievement');
      } else if (latest?.type === 'contract_complete') {
        playSound('notification');
      } else if (latest?.type === 'training_complete') {
        playSound('training');
      } else if (latest?.type === 'lease_expired') {
        playSound('notification');
      } else if (latest) {
        playSound('notification');
      }
    }
    prevNotifCountRef.current = count;
  }, [notifications, playSound]);

  useEffect(() => {
    const count = (inbox || []).length;
    // Skip first render (initial hydration / welcome seed should not ding).
    if (prevInboxCountRef.current !== null && count > prevInboxCountRef.current) {
      playSound('inboxDing');
    }
    prevInboxCountRef.current = count;
  }, [inbox, playSound]);
};
